import { createContext } from "react";

const TaskContext = createContext(null);

export default TaskContext;